module.exports = __webpack_public_path__ + "img/55_71.aed97c46.png";